import { useQuery } from '@tanstack/react-query'

import type { ModelsClubResponse } from '@/api/generated-api'
import { loadApiClient } from '@/shared/api/lazyClient'
import { useAuthStore } from '@/stores/authStore'
import { getSessionTokenPayload } from '@/utils/auth'

interface UseClubMeOptions {
  enabled?: boolean
}

export function useClubMe({ enabled = true }: UseClubMeOptions = {}) {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)
  const isClubUser = Boolean(
    getSessionTokenPayload()?.roles?.includes('USER_ROLE_CLUB')
  )

  const query = useQuery<ModelsClubResponse | null>({
    queryKey: ['clubs', 'me', isAuthenticated, isClubUser],
    queryFn: async () => {
      try {
        const api = await loadApiClient()
        const response = await api.v2ClubsMeList()
        return response
      } catch {
        return null
      }
    },
    enabled: enabled && isAuthenticated && isClubUser,
    retry: false
  })

  return {
    // eslint-disable-next-line @tanstack/query/no-rest-destructuring -- convenience API: callers destructure { data, isLoading, hasToken } (OCE-527)
    ...query,
    hasToken: isAuthenticated,
    isClubUser
  }
}
